import React from 'react';
import createMuiTheme from '@material-ui/core/styles/createTheme';
import { ThemeProvider } from '@material-ui/core/styles';

import './Resources/Fonts/MontserratFont';

export const theme = createMuiTheme({
  palette: {
    secondary: {
      main: '#f44336',
      contrastText: '#ffffff',
    },
    primary: {
      main: '#8D8E92',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: ['"Montserrat"', 'sans-serif'].join(', '),
    h3: {
      fontSize: '1.125rem',
    },
    body1: {
      fontSize: 'inherit',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: 0,
      },
    },
  },
  media: {
    portrait: '@media (orientation: portrait)',
    landscape: '@media (orientation: landscape)',
  },
});

export const CustomThemeProvider = (props) => <ThemeProvider theme={theme} {...props} />;
